import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import { artefaktService } from "../service/artefakt-service.js";
import { entscheidungenService } from "../service/entscheidungen-service.js";
import {
  loadDrucksache,
  loadDrucksachenListe,
  loadEntscheidungenStammdaten,
  loadSitzung,
} from "./entscheidungen-actions.js";

/**
 * Effects von Block 2 — Action rein, Action raus.
 *
 * `switchMap` überall: Wer schnell zwischen Seiten wechselt, löst mehrere
 * Abfragen aus; gültig ist immer die letzte.
 */

/** Das Listen-Artefakt — kein Firestore, ein Abruf je Sitzung. */
export const loadDrucksachenListeEffect = actions$.pipe(
  ofType(loadDrucksachenListe.action),
  switchMap(() =>
    artefaktService.ladeDrucksachenListe().pipe(
      map((liste) => loadDrucksachenListe.success(liste)),
      catchError((err) => of(loadDrucksachenListe.fail(err))),
    ),
  ),
);

export const loadDrucksacheEffect = actions$.pipe(
  ofType(loadDrucksache.action),
  switchMap((action) =>
    entscheidungenService.ladeDrucksache(action.payload).pipe(
      map((mitWeg) => loadDrucksache.success(mitWeg)),
      catchError((err) => of(loadDrucksache.fail(err))),
    ),
  ),
);

export const loadSitzungEffect = actions$.pipe(
  ofType(loadSitzung.action),
  switchMap((action) =>
    entscheidungenService.ladeSitzung(action.payload).pipe(
      map((daten) => loadSitzung.success(daten)),
      catchError((err) => of(loadSitzung.fail(err))),
    ),
  ),
);

export const loadStammdatenEffect = actions$.pipe(
  ofType(loadEntscheidungenStammdaten.action),
  switchMap(() =>
    entscheidungenService.ladeStammdaten().pipe(
      map((stammdaten) => loadEntscheidungenStammdaten.success(stammdaten)),
      catchError((err) => of(loadEntscheidungenStammdaten.fail(err))),
    ),
  ),
);

export const entscheidungenEffects = [
  loadDrucksachenListeEffect,
  loadDrucksacheEffect,
  loadSitzungEffect,
  loadStammdatenEffect,
];
